module.exports = "/React/dist/d4f2480e43f162bc508d89e5cc19e628.png";